// 会员关系路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/order',
  component: Layout,
  children: [
    {
      path: 'guideOrder',
      component: () => import('@/view/order/guideOrder'),
      name: '导购订单列表'
    }
  ]
}
